import styledSystemShouldForwardProp from '@styled-system/should-forward-prop';
import { StylesProps, variant } from 'styled-system';

import { FunctionInterpolation, VariantWithProp } from './types';

export const getVariantProp = <
  TComponentProps,
  K extends keyof TComponentProps & string
>(
  params: VariantWithProp<K, Required<TComponentProps>[K]>
): FunctionInterpolation<TComponentProps> => variant(params);

type IntrinsicElementsTags = Extract<keyof JSX.IntrinsicElements, string>;
type IntrinsicElementKeys<Tag extends IntrinsicElementsTags> = Extract<
  keyof JSX.IntrinsicElements[Tag],
  string
>;

export const shouldForwardProp = <Tag extends IntrinsicElementsTags>(
  propName: string
): propName is Exclude<IntrinsicElementKeys<Tag>, keyof StylesProps> =>
  styledSystemShouldForwardProp(propName);
